import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePutRequest } from 'utils/api'
import urls from 'utils/urls'
import { Box } from '@mui/material'

export default function EditOperationForm({ params, setEditForm, weekNo, fetchOperations }) {
  const [open, setOpen] = useState(true)
  const [title, setTitle] = useState('Modifier recette')
  const [selectedCategorie, setSelectedCategorie] = useState({})
  const [selectedPlat, setSelectedPlat] = useState({})
  const [selectedCuisine, setSelectedCuisine] = useState({})
  const [selectedRepas, setSelectedRepas] = useState({})

  const [categorie, setCategorie] = useState([])
  const [plat, setPlat] = useState([])
  const [cuisine, setCuisine] = useState([])
  const [repas, setRepas] = useState([])

  const log = () => {
    setSelectedCategorie(getValues('Categorie'))
    setSelectedCuisine(getValues('TypeDeCuisine'))
    setSelectedPlat(getValues('TypeDePlat'))
    setSelectedRepas(getValues('TypeDeRepas'))
  }
  useEffect(() => {
    log()
    fetchFilters()
  }, [])

  const { handleSubmit, control, setValue, reset, getValues } = useForm({
    defaultValues: {
      id: params[0].id,
      Categorie: params[0].Categorie
        ? { label: params[0].categorie.Name, id: params[0].categorie.id }
        : '',
      TypeDePlat: params[0].TypeDePlat
        ? { label: params[0].typeDePlat.Name, id: params[0].typeDePlat.id }
        : '',
      TypeDeCuisine: params[0].TypeDeCuisine
        ? { label: params[0].typeDeCuisine.Name, id: params[0].typeDeCuisine.id }
        : '',
      TypeDeRepas: params[0].TypeDeRepas
        ? { label: params[0].TypeDeRepas, id: params[0].TypeDeRepas }
        : '',
      Nom: params[0].Nom,
      TempsDePreparationH: params[0].TempsDePreparationH,
      TempsDePreparationMin: params[0].TempsDePreparationMin,
      TempsDeCuissonH: params[0].TempsDeCuissonH,
      TempsDeCuissonMin: params[0].TempsDeCuissonMin,
      Servir: params[0].Servir,
      Description: params[0].Description,
      LienVideo: params[0].LienVideo,
    },
  })

  const handleClose = () => {
    setEditForm(false)
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      TypeDeRepas: data.TypeDeRepas.label,
      Categorie: data.Categorie.id,
      TypeDePlat: data.TypeDePlat.id,
      TypeDeCuisine: data.TypeDeCuisine.id,
    }
    const formData = new FormData()
    for (const key in payload) {
      formData.append(`${key}`, `${payload[key]}`)
    }
    const response = await makePutRequest(
      urls.crudRecettesOperations + `${data.id}/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )

    if (response.status === 200) {
      fetchOperations('', weekNo)

      handleClose()
    }
  }

  const fetchFilters = async () => {
    const url = urls.getFilters + '?all=true'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setCategorie(data.category)
      setPlat(data.plat)
      setCuisine(data.cuisine)
      setRepas(data.repas)
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>{title}</DialogTitle>

        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Nom"
              label="Nom de la recette"
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Categorie', j)
                setSelectedCategorie(j)
              }}
              label="Catégorie"
              data={categorie}
              name="Categorie"
              required={true}
              selectedValue={selectedCategorie}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('TypeDeRepas', j)
                setSelectedRepas(j)
              }}
              label="Type de repas"
              data={repas}
              name="TypeDeRepas"
              required={true}
              selectedValue={selectedRepas}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('TypeDePlat', j)
                setSelectedPlat(j)
              }}
              label="Type de plat"
              data={plat}
              name="TypeDePlat"
              required={true}
              selectedValue={selectedPlat}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('TypeDeCuisine', j)
                setSelectedCuisine(j)
              }}
              label="Type de cuisine"
              data={cuisine}
              name="TypeDeCuisine"
              required={true}
              selectedValue={selectedCuisine}
            />

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',

                fontWeight: 700,
                whiteSpace: 'nowrap',
              }}
            >
              Temps de prération
              <Input
                control={control}
                inputProps={{
                  variant: 'outlined',
                  type: 'number',
                  required: true,
                  size: 'small',
                }}
                rules={{ required: true }}
                name="TempsDePreparationH"
                label="H"
              />
              H
              <Input
                control={control}
                inputProps={{
                  variant: 'outlined',
                  type: 'number',
                  required: true,
                  size: 'small',
                }}
                rules={{ required: true }}
                name="TempsDePreparationMin"
                label="min"
              />
              min
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',

                fontWeight: 700,
                whiteSpace: 'nowrap',
              }}
            >
              Temps de caisson
              <Input
                control={control}
                inputProps={{
                  variant: 'outlined',
                  type: 'number',
                  required: true,
                  size: 'small',
                }}
                rules={{ required: true }}
                name="TempsDeCuissonH"
                label="H"
              />
              H
              <Input
                control={control}
                inputProps={{
                  variant: 'outlined',
                  type: 'number',
                  required: true,
                  size: 'small',
                }}
                rules={{ required: true }}
                name="TempsDeCuissonMin"
                label="min"
              />
              min
            </Box>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Servir"
              label="Nombre de personne"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rows={4}
              multiline
              rules={{ required: true }}
              name="Description"
              label="Description recette"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="LienVideo"
              label="Lien vidéo"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
